import React from 'react';
import styled from 'styled-components';

const HeaderContainer = styled.div`
  width: 100%;
  margin-bottom: 32px;

  @media (max-width: 768px) {
    margin-bottom: 24px;
  }
`;

const TitleRow = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 16px;
`;

const StepTitle = styled.h2`
  font-size: 20px;
  font-weight: 600;
  color: #ffffff;
  margin: 0;
`;

const StepInfo = styled.div`
  font-size: 14px;
  color: #94a3b8;
  font-weight: 500;
`;

const ProgressBarContainer = styled.div`
  width: 100%;
  height: 8px;
  background: rgba(255, 255, 255, 0.1);
  border-radius: 4px;
  overflow: hidden;
`;

const ProgressBarFill = styled.div`
  height: 100%;
  background: linear-gradient(90deg, #fa4616 0%, #ff6b45 100%);
  border-radius: 4px;
  transition: width 0.3s ease;
  width: ${(props) => props.progress}%;
`;

const ProgressHeader = ({ currentStep, totalSteps, stepTitle }) => {
  const progress = (currentStep / totalSteps) * 100;

  return (
    <HeaderContainer>
      <TitleRow>
        <StepTitle>{stepTitle}</StepTitle>
        <StepInfo>
          Step {currentStep} of {totalSteps}
        </StepInfo>
      </TitleRow>
      <ProgressBarContainer>
        <ProgressBarFill progress={progress} />
      </ProgressBarContainer>
    </HeaderContainer>
  );
};

export default ProgressHeader;
